import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['hiddenField']

  remove(event) {
    if (this.data.get('soft-delete')) {
      $(this.hiddenFieldTarget).val(new Date(Date.now()))
    } else {
      $(this.hiddenFieldTarget).val('true')
    }

    $(this.element).hide()
    $(this.element).find('input').prop('required', false)

    event.preventDefault()
  }
}
